<div class="flex flex-row">
  <span>Guardando datos</span>
  <mat-spinner [diameter]="20"></mat-spinner>
  <button mat-icon-button aria-label="cerrar" (click)="close()">
    <mat-icon>close</mat-icon>
  </button>
</div>